// 路由配置 —— HashRouter（Tauri file:// + Web /app/ 通吃）
//   /              Login        - 已登录自动跳 /rooms
//   /auth-success  AuthSuccess  - magic link 验证后落地
//   /rooms         ChatLayout (RequireAuth) - 需登录
//   /rooms/:id     Room (RequireAuth)

import { createHashRouter } from "react-router-dom";

import { AppShell } from "./components/AppShell";
import { ChatLayout } from "./components/ChatLayout";
import { EmptyState } from "./components/EmptyState";
import { RequireAuth } from "./components/RequireAuth";
import { AuthSuccessPage } from "./pages/AuthSuccess";
import { ChangePasswordPage } from "./pages/ChangePassword";
import { ForgotPasswordPage } from "./pages/ForgotPassword";
import { HelpPage } from "./pages/Help";
import { InvitePage } from "./pages/Invite";
import { LoginPage } from "./pages/Login";
import { ResetPasswordPage } from "./pages/ResetPassword";
import { RoomPage } from "./pages/Room";
import { SettingsPage } from "./pages/Settings";

export const router = createHashRouter([
  {
    element: <AppShell />,
    children: [
      { path: "/", element: <LoginPage /> },
      { path: "auth-success", element: <AuthSuccessPage /> },
      { path: "forgot-password", element: <ForgotPasswordPage /> },
      { path: "reset-password", element: <ResetPasswordPage /> },
      { path: "change-password", element: <ChangePasswordPage /> },
      {
        path: "settings",
        element: (
          <RequireAuth>
            <SettingsPage />
          </RequireAuth>
        ),
      },
      { path: "invite/:token", element: <InvitePage /> },
      { path: "help", element: <HelpPage /> },
      {
        path: "rooms",
        element: (
          <RequireAuth>
            <ChatLayout />
          </RequireAuth>
        ),
        children: [
          { index: true, element: <EmptyState /> },
          { path: ":roomId", element: <RoomPage /> },
        ],
      },
    ],
  },
]);
